(function (_) {
    'use strict';

    _['PRODUCTS.CATALOG.TOCART.PRECONFIRM'] = 'To cart';
    _['PRODUCTS.CATALOG.TOCART.CONFIRM'] = 'Add';
    _['PRODUCTS.PRODUCT.TOCART.CONFIRM'] = 'Add to cart';
    _['PRODUCTS.CATEGORY'] = 'Category';
    _['PRODUCTS.PRICE'] = 'Price';
    _['PRODUCTS.TAGS'] = 'Tags';
    _['PRODUCTS.FEATURES'] = 'Features';
    _['PRODUCTS.BRAND'] = 'Brand';

    _['PRODUCTS.FILTERS'] = 'Filters';
    _['PRODUCTS.FILTERS.FILTER'] = 'Filter';
    _['PRODUCTS.FILTERS.DELETE'] = 'Remove filters';
    _['PRODUCTS.FILTERS.NAME.LABEL'] = 'Name';
    _['PRODUCTS.FILTERS.NAME.PLACEHOLDER'] = 'Filter by words...';
    _['PRODUCTS.FILTERS.CATEGORY.LABEL'] = 'Category';
    _['PRODUCTS.FILTERS.CATEGORY.DEFAULT'] = 'Filter by category...';
    _['PRODUCTS.FILTERS.SUBCATEGORY.LABEL'] = 'Subcategory';
    _['PRODUCTS.FILTERS.SUBCATEGORY.DEFAULT'] = 'Filter by subcategory...';
    _['PRODUCTS.FILTERS.PRICE.LABEL'] = 'Order by';
    _['PRODUCTS.FILTERS.PRICE.DEFAULT'] = 'Order by';
    _['PRODUCTS.FILTERS.PRICE.ASC'] = 'Price from low to high';
    _['PRODUCTS.FILTERS.PRICE.DESC'] = 'Price from high to low';

    _['PRODUCTS.PRODUCT.SIZE'] = 'Size';
    _['PRODUCTS.PRODUCT.COLOR'] = 'Color';
    _['PRODUCTS.PRODUCT.NOSTOCK'] = 'Out of stock!';
    _['PRODUCTS.PRODUCT.NOSTOCKATORDER'] = 'Sorry! You have exceed the maximum allowed stock of this product.';
    _['PRODUCTS.PRODUCT.TOOMUCHAMOUNT'] = 'Too much!';
    _['PRODUCTS.PRODUCT.AMOUNT'] = 'Amount';

}(translations['en']));





// WEBPACK FOOTER //
// ./src/app/plugins/products/lang/products-lang_en.js